import { IClient } from 'client/IClientInfo'
import React from 'react'
import TopNavExpLinkAuth from './TopNavExpLinkAuth'
import TopNavExpLinkNotAuth from './TopNavExpLinkNotAuth'

interface IExpandedProps {
  user: IClient | null
  isExpanded: boolean
  onClick: VoidFunction
  onLogout: (event: React.MouseEvent<HTMLAnchorElement>) => void
  onLogin: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const TopNavExpanded: React.FC<IExpandedProps> = ({
  user,
  isExpanded,
  onClick,
  onLogout,
  onLogin,
}) => {
  return (
    <>
      <div
        className='top-menu-expanded px-5 py-4'
        style={{
          display: isExpanded ? 'block' : '',
          // animationDuration: '3s',
          // animationName: 'slidein',
        }}
      >
        {user ? (
          <TopNavExpLinkAuth onClick={onClick} onLogout={onLogout} />
        ) : (
          <TopNavExpLinkNotAuth onClick={onClick} onLogin={onLogin} />
        )}
      </div>
      <div
        style={{ display: isExpanded ? 'block' : 'none' }}
        className='overlay'
        onClick={onClick}
      />
    </>
  )
}
export default TopNavExpanded
